export default __webpack_public_path__ + "static/media/img-heroLogoRotate-poster.bb6dfb78.png";